
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 300 300"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0v300h300V0H0zm258.31 243.45l-81.1 47.01a53.739 53.739 0 01-53.74.09l-81.26-46.74a53.754 53.754 0 01-26.95-46.49l-.16-93.74A53.727 53.727 0 0141.89 57L123 9.99a53.739 53.739 0 0153.74-.09L258 56.64a53.766 53.766 0 0126.95 46.49l.16 93.74c.02 19.2-10.19 36.96-26.8 46.58z"}})])
          )
        }
      }
    